import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import { BACKEND_URL } from '../config/constants';

const PdfPacotes = ({ title, list, theme }) => {
  const componentRef = useRef();
  const textIcon = (theme === 'dark' ? '_dark' : '');

  const handlePrint = useReactToPrint({
    documentTitle: 'Relatório Monitoramento de Pacotes',
    content: () => componentRef.current,
  });

  return (
    <>
      <button className={'buttonIcon ' + theme} onClick={handlePrint}><img src={"/img/icon_printer" + textIcon + ".svg"} alt="" /></button>
      <div style={{ display: 'none' }}>
        <div ref={componentRef} style={{ width: '100%', height: window.innerHeight }}>
          <div className='inforow' style={{ marginTop: '40px', marginLeft: '80px', marginRight: '80px' }}>
            <div className="inforow right">
              <h3 style={{ fontSize: '20px' }}>{title}</h3 >
            </div>
            <div className="inforow left">
              <img src="/img/logo_powered_insightcare.png" alt="Insightcare" style={{ width: '12vw', position: 'relative', marginLeft: '32px', float: 'right' }} />
              {
                BACKEND_URL.includes('gruposanta') ? (
                  <img src="/img/logo_gruposanta.png" alt="Gruposanta" style={{ width: '12vw', position: 'relative', float: 'right', marginLeft: '25px' }} />
                ) : null
              }
            </div>
          </div>
          <div className="inforow" style={{ marginLeft: '80px', marginRight: '80px' }}>
            <div className='inforow right'>
              <div className='infoText' style={{ fontSize: '12px' }}>Mostrando {list.length} pacientes </div>
            </div>
            <div className='inforow left'>
              <div className='infoText' style={{ fontSize: '12px' }}>Impresso em {moment().format('HH:mm, [dia] D [de] MMMM [de] YYYY')}</div>
            </div>
          </div>
          <div className='tablePDF'>
            <table>
              <thead>
                <tr>
                  <th>Leito</th>
                  <th>Paciente</th>
                  <th>Convenio</th>
                  <th>Média</th>
                  <th>Dias </th>
                  <th>Total</th>
                  <th>Pacotes</th>
                  <th>Empacotado</th>
                  <th>Aberto</th>
                </tr>
              </thead>
              <tbody>
                {list.map((data) => {
                  let formatter = new Intl.NumberFormat('PT-BR', { style: 'currency', currency: 'BRL' });
                  let key = data.CODIGOATENDIMENTO
                  let status = "-";
                  let color = '';
                  let statusClass = "ready";
                  let tdClassRx = "";
                  let spanClassRx = "";
                  let tdClassFarm = "";
                  let spanClassFarm = "";
                  let name = data.NOMEPACIENTE.split(' ')[0] + ' ' + data.NOMEPACIENTE.split(' ').slice(-1).join(' ');

                  status = "Aguardando coleta";
                  statusClass = "waiting";
                  //tdClassRx="attention";
                  //spanClassRx="attention-circle";

                  if (parseInt(data.TOTALEMPACOTADO) > parseInt(data.TOTALPACOTE)) {
                    color = 'red';
                    statusClass = "canceled";
                    // tdClassFarm="attention";
                    // spanClassFarm="attention-circle";
                  } else {
                    spanClassFarm = "success-circle";
                  }

                  return (
                    <tr key={key} className={statusClass}>
                      <td style={{ color: color }} align="left"><b>{data.LEITO}</b></td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left"><b>{name}</b>  ({data.CODIGOATENDIMENTO})</td>
                      <td style={{ color: color }} align="left"><b>{data.CONVENIO.slice(0, 14)}</b></td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap' }} align="left">{formatter.format(data.MEDIATOTAL)}</td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap' }} align="left">{data.DIAS}</td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap' }} align="left">{formatter.format(data.TOTALFATURADO)}</td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap' }} align="left">{formatter.format(data.TOTALPACOTE)}</td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left">{formatter.format(data.TOTALEMPACOTADO)}</td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap' }} align="left">{formatter.format(data.TOTALABERTO)}</td>
                    </tr>
                  )
                })
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default PdfPacotes;